export default "__VITE_ASSET__Mfr5Rrdz__"